const TedItemsIcon = () => (
  <div>
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.58922 1.70156L11.0309 3.2299C12.0226 3.6674 12.0226 4.39073 11.0309 4.82823L7.58922 6.35656C7.19839 6.53156 6.55672 6.53156 6.16589 6.35656L2.72422 4.82823C1.73255 4.39073 1.73255 3.6674 2.72422 3.2299L6.16589 1.70156C6.55672 1.52656 7.19839 1.52656 7.58922 1.70156Z"
        stroke="#9E9E9E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.75 6.41406C1.75 6.90406 2.1175 7.4699 2.56667 7.66823L6.5275 9.4299C6.83083 9.56406 7.175 9.56406 7.4725 9.4299L11.4333 7.66823C11.8825 7.4699 12.25 6.90406 12.25 6.41406"
        stroke="#9E9E9E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.75 9.33594C1.75 9.87844 2.07083 10.3684 2.56667 10.5901L6.5275 12.3518C6.83083 12.4859 7.175 12.4859 7.4725 12.3518L11.4333 10.5901C11.9292 10.3684 12.25 9.87844 12.25 9.33594"
        stroke="#9E9E9E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
);
export default TedItemsIcon;
